import React, { useRef, useState } from 'react';
import './styles/App.css';
import content from './data/content.json';
import Navigation from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
    const [language, setLanguage] = useState('en');
    const homeRef = useRef(null);
    const featuresRef = useRef(null);
    const contactRef = useRef(null);

    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    const toggleLanguage = () => {
        setLanguage(language === 'en' ? 'tr' : 'en');
    };

    const texts = content[language];

    return (
        <div className="App">
            <Navigation
                texts={texts}
                scrollToSection={scrollToSection}
                toggleLanguage={toggleLanguage}
                homeRef={homeRef}
                featuresRef={featuresRef}
                contactRef={contactRef}
            />
            <div ref={homeRef}><Hero texts={texts} /></div>
            <div ref={featuresRef}><Features texts={texts} /></div>
            <div ref={contactRef}><Contact texts={texts} /></div>
            <Footer texts={texts} />
        </div>
    );
}

export default App;